import { session } from '../helpers/helpers';
import { addBreadcrumb, logUserAction } from './logger';

let pendingMutatingRequestsCount = 0;

const notifyStoreSelectState = () => {
  const isPending = pendingMutatingRequestsCount > 0;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('storeSelectLockChange', { detail: { locked: isPending } }));
  }
};

const apiInstance = async (url, method = 'GET', body = null) => {
  const token = session.get('token'); // Получаем токен из сессии
  const urlStr = typeof url === 'string' ? url : String(url);
  const isLogEndpoint = urlStr.includes('/api/user-action-logs');
  const isChangeStoreEndpoint = urlStr.includes('/api/user/change-contact-store');

  const isMutating = method !== 'GET' && !isLogEndpoint && !isChangeStoreEndpoint;

  if (isMutating) {
    pendingMutatingRequestsCount++;
    notifyStoreSelectState();
  }

  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '', // Добавляем токен только если он есть
  };

  const options = {
    method,
    headers,
  };

  // Если метод не GET и есть body, добавляем его в запрос
  if (body && method !== 'GET') {
    options.body = JSON.stringify(body);
  }

  if (!isLogEndpoint) {
    addBreadcrumb('api.request', `${method} ${urlStr.replace(/^https?:\/\/[^/]+/, '')}`);
  }

  try {
    const response = await fetch(url, options);

    // Проверка на успешность ответа
    if (!response.ok) {
      if (response.status === 401) {
        console.warn('Unauthorized access. Logging out...');
        session.remove('token'); // Очищаем сессию
        window.location.href = '/signin'; // Перенаправляем пользователя на страницу входа
        return;
      }

      const errorText = await response.text();
      let parsedMessage = errorText;
      try {
        const parsed = JSON.parse(errorText);
        if (parsed?.error?.message) {
          parsedMessage = parsed.error.message;
        } else if (parsed?.message) {
          parsedMessage = parsed.message;
        }
      } catch (e) {
        // Not a JSON, keep original text
      }

      const error = {
        status: response.status,
        statusText: response.statusText,
        responseBody: parsedMessage,
      };
      console.error('API Error:', error); // Логируем более подробную информацию

      if (!isLogEndpoint) {
        logUserAction({
          action: 'API_HTTP_ERROR',
          level: 'error',
          message: `[${method}] ${urlStr} (${response.status}) -> ${parsedMessage}`,
          details: {
            url: urlStr,
            method,
            status: response.status,
            statusText: response.statusText,
            responseBody: parsedMessage,
          },
        });
      }

      throw new Error(error.responseBody);
    }

    // Преобразуем ответ в JSON
    return await response.json();
  } catch (error) {
    // Логируем ошибку и возвращаем ее
    console.error('API Error:', error);
    if (!isLogEndpoint && error.message !== 'Unauthorized access') {
      addBreadcrumb('api.error', `[${method}] ${urlStr}: ${error.message}`);
    }
    throw error;
  } finally {
    if (isMutating) {
      pendingMutatingRequestsCount = Math.max(0, pendingMutatingRequestsCount - 1);
      notifyStoreSelectState();
    }
  }
};

export { apiInstance };

